import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useCalculator } from '../context/CalculatorContext';
import { motion } from 'framer-motion';

export function Header() {
  const { currentModule, setModule } = useCalculator();

  return (
    <motion.header 
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="sticky top-0 z-50 w-full border-b border-slate-200/80 bg-white/95 backdrop-blur-md"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center gap-4">
            {currentModule && (
              <Button
                variant="ghost"
                size="sm"
                onClick={() => setModule(null)}
                className="gap-2 text-slate-600 hover:text-slate-900"
                data-testid="back-button"
              >
                <ArrowLeft className="h-4 w-4" />
                Volver
              </Button>
            )}
            <div className="flex items-center gap-3">
              <img 
                src="/logo-vitamina-icon.png" 
                alt="Vitamina Online" 
                className="w-10 h-10 rounded-xl"
              />
              <div>
                <h1 className="text-lg font-bold text-slate-900 tracking-tight">
                  Calculadora de Pauta
                </h1>
                <p className="text-xs text-slate-500 font-medium">
                  Vitamina Online
                </p>
              </div>
            </div>
          </div>
          
          <div className="flex items-center gap-3">
            <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-100 text-slate-600 text-sm font-medium">
              <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
              MXN
            </div>
          </div>
        </div>
      </div>
    </motion.header>
  );
}
